import { markRaw } from 'vue';
import { toast as sonnerToast } from 'vue-sonner';
import AuxoBanner from '@/components/auxo/AuxoBanner.vue';

function generateId() {
  return `alert-toast-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

// Renders `component` as the toast body via vue-sonner's toast.custom(),
// unstyled so the component supplies the entire visual — vue-sonner only
// drives stacking, positioning, and auto-dismiss. toast.custom() renders with
// no slot passthrough (props only), so content components must accept their
// content via props, not a default slot. `onClose` is injected automatically,
// so content components just need to declare `emits: ['close']` and call
// `emit('close')` — Vue wires that straight to it.
export function showContentToast(component, props, options = {}) {
  const id = options.id ?? generateId();

  // markRaw, or vue-sonner's reactive toast list proxies the component itself
  // and Vue warns on every render — loudest for a toast that never auto-closes.
  sonnerToast.custom(markRaw(component), {
    unstyled: true,
    ...options,
    id,
    componentProps: {
      ...props,
      onClose: () => sonnerToast.dismiss(id),
    },
  });

  return id;
}

function showAlert(variant, message, options) {
  return showContentToast(
    AuxoBanner,
    { variant, layout: 'short', hasCloseIcon: true, message },
    options
  );
}

export const toast = {
  info: (message, options) => showAlert('info', message, options),
  success: (message, options) => showAlert('success', message, options),
  warning: (message, options) => showAlert('warning', message, options),
  error: (message, options) => showAlert('error', message, options),
};
